<script setup lang="ts">
defineProps<{
  quote: string
  author: string
  role: string
}>()
</script>

<template>
  <div class="test-card">
    <div class="stars">★★★★★</div>
    <blockquote>"{{ quote }}"</blockquote>
    <p class="author">— {{ author }}, {{ role }}</p>
  </div>
</template>

<style scoped>
.test-card {
  background: var(--card);
  border-radius: 16px;
  padding: 36px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.test-card .stars {
  color: #f5a623;
  font-size: 1rem;
  margin-bottom: 16px;
  letter-spacing: 2px;
}

.test-card blockquote {
  font-family: 'HNT', sans-serif;
  font-size: 0.95rem;
  color: var(--text);
  line-height: 1.7;
  font-style: italic;
  margin-bottom: 20px;
}

.test-card .author {
  font-family: 'HND', sans-serif;
  font-size: 0.8rem;
  color: rgba(255, 255, 255, 0.45);
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

@media (max-width: 768px) {
  .test-card {
    padding: 24px;
  }

  .test-card blockquote {
    font-size: 0.9rem;
  }
}
</style>
